export const environment = {
    production: false,
    logLevel: 5,
    firebaseConfig: {
        apiKey: "AIzaSyDWbSx2YYQXNmFqvJ8YkSqyk-NuSMwQjZQ",
        authDomain: "rooftop-stg.firebaseapp.com",
        databaseURL: "https://rooftop-stg-default-rtdb.firebaseio.com",
        projectId: "rooftop-stg",
        storageBucket: "rooftop-stg.firebasestorage.app",
        messagingSenderId: "895798999772",
        appId: "1:895798999772:web:a1827f05cfef27abf05219",
        measurementId: "G-BMCR9SDDZY",
        locationId: "asia-south1",
    },
    authUrl: 'https://api01.stg.mum.in.rooftopapp.com/oauth2/token',
    authBasic: 'cm9vZnRvcF9zdGdfYXBwOjV4UHNqd2o0eHlneldzQw==',
    apiUrl: 'https://api01.stg.mum.in.rooftopapp.com/v1',
    cmsUrl: 'https://cms.rooftopapp.com/api',
    razorpayKey: 'rzp_test_28BHfPTm3QoqRV',
    googleMapsApiKey: 'AIzaSyC88c8YCESn53y3nTCOW0O0B_ThjB8i3gI',
    gtmId: 'GTM-T25MRJMW',
    appCheckSiteKey: '6LeRG-4qAAAAAEQYRlGAEE5j08zRG2tletRkDUxD'
};
